import { useEffect, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem("monaco_session_id");
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem("monaco_session_id", sessionId);
  }
  return sessionId;
};

const useAnalytics = () => {
  const sessionId = getSessionId();

  const trackEvent = useCallback(async (eventType, data = {}) => {
    try {
      await axios.post(`${API}/analytics/event`, {
        event_type: eventType,
        session_id: sessionId,
        ...data
      });
    } catch (error) {
      // Silent fail - analytics shouldn't break the app
      console.debug("Analytics tracking failed:", error);
    }
  }, [sessionId]);

  // Track page view
  const trackPageView = useCallback((page) => {
    trackEvent("page_view", { page });
  }, [trackEvent]);

  // Track girl click
  const trackGirlClick = useCallback((girlId, girlName) => {
    trackEvent("girl_click", { girl_id: girlId, girl_name: girlName });
  }, [trackEvent]);

  // Track button click
  const trackButtonClick = useCallback((buttonId) => {
    trackEvent("button_click", { button_id: buttonId });
  }, [trackEvent]);

  // Track filter use
  const trackFilterUse = useCallback((filterType, filterValue) => {
    trackEvent("filter_use", { filter_type: filterType, filter_value: filterValue });
  }, [trackEvent]);

  // Track newsletter open (via pixel or redirect)
  const trackNewsletterOpen = useCallback((newsletterId) => {
    trackEvent("newsletter_open", { newsletter_id: newsletterId });
  }, [trackEvent]);

  // Track newsletter click
  const trackNewsletterClick = useCallback((newsletterId) => {
    trackEvent("newsletter_click", { newsletter_id: newsletterId });
  }, [trackEvent]);

  return {
    trackPageView,
    trackGirlClick,
    trackButtonClick,
    trackFilterUse,
    trackNewsletterOpen,
    trackNewsletterClick,
    trackEvent
  };
};

export default useAnalytics;
